// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {ProjectNickname} from './ProjectNickname';
import {Location} from './Location';
import {TaxLotProject} from './TaxLotProject';
import {Address} from './Address';
import {ProjectStakeholderRelationship} from './ProjectStakeholderRelationship';
import {ProjectStatus} from './ProjectStatus';
import {River} from './River';
import {Huc} from './Huc';
import {Ecoregion} from './Ecoregion';
import {ConservationAction} from './ConservationAction';
import {ContextNodeSpeciesList} from './ContextNodeSpeciesList';

const _associations = [
			{
				name: 'ProjectNicknames',
				model: new ProjectNickname(),
				type: 'ArrayOfChildren',
				using: 'projectId',
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'Nicknames or other names the project is known by that are different than river mile.',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 11,
				itemTitle: 'Nicknames',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'Location',
				model: new Location(),
				type: 'ParentPointer',
				using: 'locationId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 22,
				itemTitle: 'Location',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'TaxLotProjects',
				model: new TaxLotProject(),
				type: 'ArrayOfChildren',
				using: 'projectId',
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 23,
				itemTitle: 'Tax Lot',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'Address',
				model: new Address(),
				type: 'ParentPointer',
				using: 'addressId',
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: true,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: 'Address',
				groupTitle: 'Address',
				displayOrder: 28,
				itemTitle: 'Address',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ProjectStakeholderRelationships',
				model: new ProjectStakeholderRelationship(),
				type: 'ArrayOfChildren',
				using: 'projectId',
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Contacts',
				groupTitle: 'Contacts',
				displayOrder: 29,
				itemTitle: 'Contact Relationship',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ProjectStatus',
				model: new ProjectStatus(),
				type: 'ArrayOfChildren',
				using: 'projectStatusId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'ProjectStatus',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'River',
				model: new River(),
				type: 'ParentPointer',
				using: 'riverId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'River',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'Huc',
				model: new Huc(),
				type: 'ParentPointer',
				using: 'hucId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'Huc',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'Ecoregion',
				model: new Ecoregion(),
				type: 'ParentPointer',
				using: 'ecoregionId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: true,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'Ecoregion',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ConservationActions',
				model: new ConservationAction(),
				type: 'ArrayOfChildren',
				using: 'projectId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'ConservationActions',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ContextNodeSpeciesList',
				model: new ContextNodeSpeciesList(),
				type: 'ArrayOfChildren',
				using: 'contextNodeId',
				isHidden: {
					requiresPermission: 'can_view_species_list'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 12,
				itemTitle: 'Species List',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'projectId',
				placeholder: null,
				key: 'projectId',
				isPrimaryKey: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.projectId,
				setter: (x, y) => x.projectId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Program',
				placeholder: null,
				key: 'programId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 1,
				getter: (x) => x.programId,
				setter: (x, y) => x.programId = y,
				defaultValue: null,
				editor: 'ProgramFieldEditor',
				viewer: 'ProgramFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'HUC',
				placeholder: null,
				key: 'hucId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 14,
				getter: (x) => x.hucId,
				setter: (x, y) => x.hucId = y,
				defaultValue: null,
				editor: 'HucFieldEditor',
				viewer: 'HucFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'River',
				placeholder: null,
				key: 'riverId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 15,
				getter: (x) => x.riverId,
				setter: (x, y) => x.riverId = y,
				defaultValue: null,
				editor: 'RiverFieldEditor',
				viewer: 'RiverFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Ecoregion',
				placeholder: null,
				key: 'ecoregionId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 16,
				getter: (x) => x.ecoregionId,
				setter: (x, y) => x.ecoregionId = y,
				defaultValue: null,
				editor: 'EcoregionFieldEditor',
				viewer: 'EcoregionFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'locationId',
				placeholder: null,
				key: 'locationId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.locationId,
				setter: (x, y) => x.locationId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'addressId',
				placeholder: null,
				key: 'addressId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.addressId,
				setter: (x, y) => x.addressId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Project Name',
				placeholder: 'Snake River RM 439.5',
				key: 'name',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'The project naming convention begins with the river name followed by RM and the river mile rounded to the nearest tenth of a mile) e.g. Snake River RM 439.5',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 2,
				getter: (x) => x.name,
				setter: (x, y) => x.name = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Short Name',
				placeholder: null,
				key: 'shortName',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'Shorter version of project name above. Useful for report titles, graph labels, and other character-constrained items.',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 3,
				getter: (x) => x.shortName,
				setter: (x, y) => x.shortName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'slug',
				placeholder: null,
				key: 'slug',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.slug,
				setter: (x, y) => x.slug = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'description',
				placeholder: null,
				key: 'description',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.description,
				setter: (x, y) => x.description = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(4000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Area',
				placeholder: null,
				key: 'area',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 17,
				getter: (x) => x.area,
				setter: (x, y) => x.area = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
					new validators.NumberOfDecimalsValidator(2),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					suffix: "ac",
					className: "sb-acres-number-editor",
				}
			},
			{
				title: 'Linear Feet of Stream',
				placeholder: null,
				key: 'distance',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 18,
				getter: (x) => x.distance,
				setter: (x, y) => x.distance = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
					new validators.NumberOfDecimalsValidator(2),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					suffix: "ft",
					className: "sb-feet-number-editor",
				}
			},
			{
				title: 'Start River Mile',
				placeholder: null,
				key: 'startRiverMile',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 19,
				getter: (x) => x.startRiverMile,
				setter: (x, y) => x.startRiverMile = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
					new validators.LessThanOtherNumericValidator('endRiverMile'),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'End River Mile',
				placeholder: null,
				key: 'endRiverMile',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 20,
				getter: (x) => x.endRiverMile,
				setter: (x, y) => x.endRiverMile = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
					new validators.GreaterThanOtherNumericValidator('startRiverMile'),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Elevation',
				placeholder: null,
				key: 'elevation',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 21,
				getter: (x) => x.elevation,
				setter: (x, y) => x.elevation = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
					new validators.NumberOfDecimalsValidator(2),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					suffix: "ft",
					className: "sb-feet-number-editor",
				}
			},
			{
				title: 'Pre Project Land Use',
				placeholder: null,
				key: 'preProjectLandUse',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Land Description',
				groupTitle: 'Land Description',
				displayOrder: 22,
				getter: (x) => x.preProjectLandUse,
				setter: (x, y) => x.preProjectLandUse = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Implementation Start Date',
				placeholder: null,
				key: 'implementationStartDate',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 11,
				getter: (x) => x.implementationStartDate,
				setter: (x, y) => x.implementationStartDate = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Project Status',
				placeholder: null,
				key: 'projectStatusId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: 'change_status_project',
				group: 'General',
				groupTitle: 'General',
				displayOrder: 9,
				getter: (x) => x.projectStatusId,
				setter: (x, y) => x.projectStatusId = y,
				defaultValue: null,
				editor: 'ProjectStatusFieldEditor',
				viewer: 'ProjectStatusFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Reason for Abandonment',
				placeholder: null,
				key: 'projectStatusNote',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'to_number(projectStatusId) != `6`',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 10,
				getter: (x) => x.projectStatusNote,
				setter: (x, y) => x.projectStatusNote = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Project Summary',
				placeholder: null,
				key: 'summary',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 13,
				getter: (x) => x.summary,
				setter: (x, y) => x.summary = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(2000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Notes',
				placeholder: null,
				key: 'notes',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 14,
				getter: (x) => x.notes,
				setter: (x, y) => x.notes = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(2000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Directions',
				placeholder: null,
				key: 'directions',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Site Access',
				groupTitle: 'Site Access',
				displayOrder: 25,
				getter: (x) => x.directions,
				setter: (x, y) => x.directions = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(2000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Special Equipment Needs',
				placeholder: null,
				key: 'specialEquipment',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Site Access',
				groupTitle: 'Site Access',
				displayOrder: 26,
				getter: (x) => x.specialEquipment,
				setter: (x, y) => x.specialEquipment = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(2000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Access Stipulations/Parking',
				placeholder: null,
				key: 'accessStipulations',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Site Access',
				groupTitle: 'Site Access',
				displayOrder: 27,
				getter: (x) => x.accessStipulations,
				setter: (x, y) => x.accessStipulations = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(2000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Landowner Notification Required',
				placeholder: null,
				key: 'landownerNotificationRequired',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Site Access',
				groupTitle: 'Site Access',
				displayOrder: 28,
				getter: (x) => x.landownerNotificationRequired,
				setter: (x, y) => x.landownerNotificationRequired = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Mobile Reach ID',
				placeholder: null,
				key: 'mobileReachId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'skips_data_segmentation'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'If this project exists in StreamBank Monitoring this value should be the mreach.ID value for the corresponding StreamBank Monitoring project.',
				requiresPermission: 'update_project',
				group: 'General',
				groupTitle: 'General',
				displayOrder: 5,
				getter: (x) => x.mobileReachId,
				setter: (x, y) => x.mobileReachId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Fulcrum ID',
				placeholder: null,
				key: 'fulcrumId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 4,
				getter: (x) => x.fulcrumId,
				setter: (x, y) => x.fulcrumId = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(36),
					new validators.IsValidUuidValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'attributes',
				placeholder: null,
				key: 'attributes',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.attributes,
				setter: (x, y) => x.attributes = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Map Caption',
				placeholder: null,
				key: 'projectMapCaption',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 7,
				getter: (x) => x.projectMapCaption,
				setter: (x, y) => x.projectMapCaption = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(2000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'contextNodeId',
				placeholder: null,
				key: 'contextNodeId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.contextNodeId,
				setter: (x, y) => x.contextNodeId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Lease Area',
				placeholder: null,
				key: 'leaseArea',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 9,
				getter: (x) => x.leaseArea,
				setter: (x, y) => x.leaseArea = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
					new validators.NumberOfDecimalsValidator(10),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
						"en",
						{"maximumFractionDigits":10},
					]
				},
				customData: {
					suffix: "ac",
					className: "sb-acres-number-editor",
				}
			},
			{
				title: 'Map File',
				placeholder: null,
				key: 'projectMapFileUploadId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 6,
				getter: (x) => x.projectMapFileUploadId,
				setter: (x, y) => x.projectMapFileUploadId = y,
				defaultValue: null,
				editor: 'FileUploadFieldEditorWithOverlay',
				viewer: 'FileUploadFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					contextNodeIdFetch: (x) => [x.contextNodeId],
				}
			},
			{
				title: 'Document File',
				placeholder: null,
				key: 'projectDocFileUploadId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 8,
				getter: (x) => x.projectDocFileUploadId,
				setter: (x, y) => x.projectDocFileUploadId = y,
				defaultValue: null,
				editor: 'FileUploadFieldEditorWithOverlay',
				viewer: 'FileUploadFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					contextNodeIdFetch: (x) => [x.contextNodeId],
				}
			},
			{
				title: 'organizationId',
				placeholder: null,
				key: 'organizationId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.organizationId,
				setter: (x, y) => x.organizationId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'parentSlug',
				placeholder: null,
				key: 'parentSlug',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.parentSlug,
				setter: (x, y) => x.parentSlug = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'grandParentSlug',
				placeholder: null,
				key: 'grandParentSlug',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.grandParentSlug,
				setter: (x, y) => x.grandParentSlug = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'contextPath',
				placeholder: null,
				key: 'contextPath',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.contextPath,
				setter: (x, y) => x.contextPath = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'assignedSpeciesListId',
				placeholder: null,
				key: 'assignedSpeciesListId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.assignedSpeciesListId,
				setter: (x, y) => x.assignedSpeciesListId = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'parentAssignedSpeciesListId',
				placeholder: null,
				key: 'parentAssignedSpeciesListId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.parentAssignedSpeciesListId,
				setter: (x, y) => x.parentAssignedSpeciesListId = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class Project extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
